import { EVENTS } from 'common/domain/constants';
import { LOANS } from 'loans.module/common/domain/constants.loans.js';

const FEE_TYPES = {
  MINIMUM_FEE_IN_MAX_PERIOD: 'minimumFeeInMaxPeriod',
  MONTHLY_FEE: 'monthlyFee',
  FIXED_FEE_NUMBER: 'fixedFeeNumber',
};

class LoansAmountSimulationController {
  constructor(EventEmitter, $log, floatingActionButtonsService, $scope, $timeout, LoansUserDataService, myLoansService) {
    'ngInject';
    this.EventEmitter = EventEmitter;
    this.scope = $scope;
    this.log = $log;
    this.errors = {};
    this.showErrorAmount = false;
    this.floatingActionButtonsService = floatingActionButtonsService;
    this.scope = $scope;
    this.timeout = $timeout;
    this.loansUserDataService = LoansUserDataService;
    this.myLoansService = myLoansService;
  }

  $onInit() {

    this.amount = 0;
    this.monthlyFeeAmount = 0;
    this.fixedFeeNumber = 0;
    this.acquisitionCost = 0;
    this.salePrice = undefined;
    this.diff = 0;
    this.feeType = FEE_TYPES.MINIMUM_FEE_IN_MAX_PERIOD;
    this.wantInsurance = false;
    this.MAX_AMOUNT = 999999999.99;
    this.isClickOnSubmit = false;
    this.hasUserEditedCharges = false;
    this.extraPendingAmount09 = 0;
    this._myLoansLoadedFor09 = false;
    this.chargesBase = this.initialCharges || 0;
    this.isChargesFocused = false;
    this._myLoansPromise = null;
    this.recalcAfterChargesChange({ refreshInput: true });
    this.minChargesBase = this.initialCharges || 0;

    this.isSimulation =
      this.simulationWitness !== undefined
        ? this.simulationWitness
        : (this.simulation && this.simulation.simulationWitness) || false;

    this.salePriceActive = 0;
    this.newHomePrice = 0;

    this.tooltipTitle();

    if (this.simulation) {
      this.assignOriginalValue(this.simulation);
      this.setDiff();
    }

    if (this.isMobileApp) {
      this.initFloatingActionButtons();
    }

  }

  $onChanges(changes) {

    if (changes.shouldShowCreditCapacitySimulation && changes.shouldShowCreditCapacitySimulation.currentValue != null) {
      this.shouldShowCreditCapacitySimulation = changes.shouldShowCreditCapacitySimulation.currentValue;

      this.syncExtraPendingFlow();

      if (this.isMobileApp) {
        this.initFloatingActionButtons();
      }
    }

    if (changes.codeOptionSelected && changes.codeOptionSelected.currentValue != null) {
      this.codeOptionSelected = changes.codeOptionSelected.currentValue;
      this.syncExtraPendingFlow();
    }

    if (changes.initialCharges && changes.initialCharges.currentValue != null) {
      this.initialCharges = changes.initialCharges.currentValue;

      if (!this.hasUserEditedCharges) {
        const incoming = this.initialCharges || 0;

        if (this.shouldApplyExtraPending()) {
          const extra = this.extraPendingAmount09 || 0;
          this.chargesBase = Math.max(0, incoming - extra);

        } else {
          this.chargesBase = incoming;

        }
        this.minChargesBase = this.chargesBase;
      }

      this.recalcAfterChargesChange({ refreshInput: true });
    }

  }

  isPurpose09() {
    return this.codeOptionSelected === LOANS.ID_HR.HOUSING_MANDATORY_PURPOSE;
  }
  shouldApplyExtraPending() {
    if (!this.shouldShowCreditCapacitySimulation) return false;

    const v = this.codeOptionSelected;

    return (
      v === LOANS.ID_HR.HOUSING_MANDATORY_PURPOSE ||
      v === LOANS.ID_HR.SOCIAL_HOUSING_LOAN ||
      v === LOANS.ID_HR.AGREEMENT_HOUSING_LOAN
    );
  }
  recalcAfterChargesChange({ refreshInput = false } = {}) {

    this.updateChargesTotal();
    if (refreshInput) this.refreshChargesInputIfPossible();
    this.setDiff();
    this.scope.$applyAsync && this.scope.$applyAsync();

  }

  resetExtraPending() {
    this.extraPendingAmount09 = 0;
    this._myLoansLoadedFor09 = false;
    this._myLoansPromise = null;
  }

  syncExtraPendingFlow() {

    if (this.shouldApplyExtraPending()) {
      this.loadPendingAmountFor09();
    } else {
      this.resetExtraPending();
      this.recalcAfterChargesChange({ refreshInput: true });
    }
  }
  updateChargesTotal() {
    if (this.shouldApplyExtraPending()) {
      this.charges = (this.chargesBase || 0) + (this.extraPendingAmount09 || 0);
    } else {
      this.charges = (this.chargesBase || 0);
    }
    this.formattedCharges = this.formatToCurrency(this.charges);

  }
  loadPendingAmountFor09() {

    if (!this.shouldApplyExtraPending()) return;
    if (this._myLoansLoadedFor09) return;

    const employeeId = this.loansUserDataService._employee.userId;

    if (this._myLoansPromise) return;

    this._myLoansPromise = this.myLoansService.getMyLoans(employeeId)
      .then((loansList) => {

        const loan = loansList.find(l =>
          (l.statusCode === LOANS.STATES.ID.IN_FORCE || l.statusCode === LOANS.STATES.ID.SUBSCRIBER) &&
          String(l.purposeCode) === String(LOANS.ID_HR.HOUSING_MANDATORY_PURPOSE) &&
          (String(l.modalityCode) === String(LOANS.ID_HR.SOCIAL_HOUSING_LOAN) || String(l.modalityCode) === String(LOANS.ID_HR.AGREEMENT_HOUSING_LOAN))
        );

        const newExtra = loan ? loan.amountPending : 0;

        this._myLoansLoadedFor09 = true;
        this._myLoansPromise = null;

        if (newExtra !== this.extraPendingAmount09) {
          this.extraPendingAmount09 = newExtra;

          if (!this.hasUserEditedCharges) {
            const incoming = this.initialCharges || 0;
            this.chargesBase = Math.max(0, incoming - newExtra);
            this.minChargesBase = this.chargesBase;
          }

          this.recalcAfterChargesChange({ refreshInput: true });

        }
      })
      .catch((err) => {
        this.log.error('Error fetching myLoans:', err);
        this.extraPendingAmount09 = 0;
        this._myLoansLoadedFor09 = false;
        this._myLoansPromise = null;
        this.recalcAfterChargesChange({ refreshInput: true });
      });
  }

  formatToCurrency(value) {
    if (value == null || isNaN(value)) return '';
    return value.toLocaleString('es-ES', {
      style: 'currency',
      currency: 'EUR',
    });
  }

  parseCurrencyInput(input) {
    if (!input) return 0;
    const raw = input
      .replace(/[€.]/g, '')
      .replace(/\./g, '')
      .replace(',', '.')
      .trim();
    return parseFloat(raw);
  }

  onBlurCharges() {
    this.isChargesFocused = false;
    this.hasUserEditedCharges = true;
    const total = this.parseCurrencyInput(this.formattedCharges);
    const currentTotal = Number(this.charges) || 0;
    const changed = Math.abs(total - currentTotal) > 0.009;

    if (!changed) {

      this.formattedCharges = this.formatToCurrency(this.charges);
      return;
    }

    this.hasUserEditedCharges = true;

    if (this.shouldApplyExtraPending()) {
      this.chargesBase = total - (this.extraPendingAmount09 || 0);
    } else {
      this.chargesBase = total;
    }

    this.updateChargesTotal();
    this.checkCharges(true);
    this.setDiff();
  }
  onFocusCharges() {
    this.isChargesFocused = true;
    this.formattedCharges = this.charges.toString().replace('.', ',');
  }

  isUsualHouseSelected() {
    return (
      this.housingLoan &&
      (this.codeOptionSelected === LOANS.ID_HR.HOUSING_MANDATORY_PURPOSE || this.codeOptionSelected === LOANS.ID_HR.SOCIAL_HOUSING_LOAN)
    );
  }

  isSocialAgreementHousingLoan() {
    return this.loan && this.loan.id === LOANS.ID.AGREEMENT_HOUSING_LOAN;
  }

  tooltipTitle() {
    let title = null;

    if (this.isUsualHouseSelected()) {
      title =
        '{{ "LOANS.SIGN_UP.TOOLTIPS.SOCIAL_HOUSING_AGREEMENT.DETAILED_INSURANCE_INFO" | translate }}';
    } else if (this.isSocialAgreementHousingLoan()) {
      title =
        '{{ "LOANS.SIGN_UP.TOOLTIPS.SOCIAL_HOUSING_AGREEMENT.DETAILED_INSURANCE_INFO2" | translate }}';
    } else {
      title = '{{ "LOANS.SIGN_UP.TOOLTIPS.INSURANCE_INFO" | translate }}';
    }

    return title;
  }

  reset() {
    this.amount = 0;
    this.monthlyFeeAmount = 0;
    this.fixedFeeNumber = 0;
    this.acquisitionCost = 0;
    this.salePrice = undefined;
    this.diff = 0;
    this.feeType = FEE_TYPES.MINIMUM_FEE_IN_MAX_PERIOD;
    this.wantInsurance = false;
    this.MAX_AMOUNT = 999999999.99;
    this.isClickOnSubmit = false;
  }

  getFormClasses() {
    return {
      'not-submit': !this.isClickOnSubmit,
    };
  }

  resetErrors() {
    this.errors = {};
    this.showErrorAmount = false;
  }

  timeOutSubmit() {
    if (!this.isHousingMandatoryPurpose) {
      this.timeout(() => {
        this.isSubmitting = false;
        this._setFloatingButtonDisabled(false);
        this.scope.$applyAsync && this.scope.$applyAsync();
      }, 4000);
    } else {
      this.isSubmitting = false;
      this._setFloatingButtonDisabled(false);
    }
  }

  submit() {
    if (this.isSubmitting) {
      return;
    }
    if (this.form && this.form.charges && !this.isChargesFocused) {
      this.onBlurCharges();
    }
    this.isSubmitting = true;
    this._setFloatingButtonDisabled(true);

    this.isClickOnSubmit = true;

    this.resetErrors();

    if (this.submitIsDisabled(this.isClickOnSubmit)) {
      this.scope.$broadcast(EVENTS.LOANS_AMOUNT_SIMULATION_REFRESH_ERRORS);
      this.scrollToErrors();
      this.isSubmitting = false;
      this._setFloatingButtonDisabled(false);
      return;
    }

    this.errors = {};
    this.scope.$broadcast(EVENTS.LOANS_AMOUNT_SIMULATION_REFRESH_ERRORS);
    this.onSubmit(this.EventEmitter(this.getFormData()));

    this.timeOutSubmit();
  }

  scrollToErrors() {
    const sizeTitleMenu = 60;
    const page = $('html, body');
    const form = $('loans-amount-simulation');
    const scrollTop = form.first().offset().top - sizeTitleMenu;
    page.animate({ scrollTop }, 500);
  }

  assignOriginalValue(simulation) {
    this.amount = simulation.amount;
    this.monthlyFeeAmount = simulation.monthlyFeeAmount || 0;
    this.fixedFeeNumber = simulation.fixedFeeNumber || 0;
    this.feeType = simulation.feeType || FEE_TYPES.MINIMUM_FEE_IN_MAX_PERIOD;
    this.wantInsurance = simulation.wantInsurance;

    if (this.wantInsurance === undefined) {
      this.wantInsurance = false;
    }

    this.acquisitionCost = simulation.acquisitionCost;
    this.salePrice = simulation.salePrice;
  }

  getFormData() {
    const isSimulation = this.simulationWitness && (this.codeOptionSelected === LOANS.ID_HR.HOUSING_MANDATORY_PURPOSE || this.codeOptionSelected === LOANS.ID_HR.SOCIAL_HOUSING_LOAN || this.codeOptionSelected === LOANS.ID_HR.AGREEMENT_HOUSING_LOAN) || false;
    const selectedSalePrice = isSimulation
      ? this.salePriceActive
      : this.salePrice;

    const formData = {
      amount: this.amount,
      feeType: this.feeType,
      monthlyFeeAmount: this.monthlyFeeAmount,
      fixedFeeNumber: this.fixedFeeNumber,
      wantInsurance: this.wantInsurance,
      salePrice: selectedSalePrice,
      diff: this.diff,
      isSimulation: isSimulation,
    };

    if (this.acquisitionCost > 0) {
      formData.acquisitionCost = this.acquisitionCost;
    }

    this.removeFeeTypesFields(formData);
    return formData;
  }

  removeFeeTypesFields(formData) {
    if (formData.feeType === FEE_TYPES.MINIMUM_FEE_IN_MAX_PERIOD) {
      delete formData.fixedFeeNumber;
      delete formData.monthlyFeeAmount;
    } else if (formData.feeType === FEE_TYPES.MONTHLY_FEE) {
      delete formData.fixedFeeNumber;
    } else {
      delete formData.monthlyFeeAmount;
    }
  }

  mandatoryInsurance() {
    let mandatory = null;
    const mandatoryInsuranceByLoan =
      this.loan && this.loan.signUp.mandatoryInsurance;

    if (mandatoryInsuranceByLoan) {
      mandatory = 'yes';
      this.wantInsurance = true;
    }

    const mandatoryInsuranceByCode =
      this.housingLoan &&
      (this.codeOptionSelected === LOANS.ID_HR.HOUSING_MANDATORY_PURPOSE || this.codeOptionSelected === LOANS.ID_HR.SOCIAL_HOUSING_LOAN || this.codeOptionSelected === LOANS.ID_HR.AGREEMENT_HOUSING_LOAN);

    if (mandatoryInsuranceByCode) {
      mandatory = 'yes';
      this.wantInsurance = true;
    }

    return mandatory;
  }

  changeInsurance($event) {
    this.wantInsurance = $event.enabled;
    this.submitIsDisabled();
  }

  isDisabledMonthlyFeeAmount() {
    return this.feeType !== FEE_TYPES.MONTHLY_FEE;
  }

  hideMonthlyFeeAmount() {
    return this.isMobileApp && this.isDisabledMonthlyFeeAmount();
  }

  isDisabledFixedFeeNumber() {
    return this.feeType !== FEE_TYPES.FIXED_FEE_NUMBER;
  }

  hideFixedFeeNumber() {
    return this.isMobileApp && this.isDisabledFixedFeeNumber();
  }

  submitIsDisabled(isSubmit) {
    const validPrevalidation = this.checkPrevalidation();
    this._emitErrorPrevalidation(validPrevalidation);
    const validAmount = this.checkAmount(isSubmit);
    const validFeeType = this.checkFeeType(isSubmit);
    const validHousingFields = this.checkHousingFields(isSubmit);
    const validForm = this.form.$valid;
    let invalid =
      !validPrevalidation || !validAmount || !validFeeType || !validForm;

    if (this.housingLoan) {
      invalid = invalid || !validHousingFields;
    }

    return invalid;
  }

  _emitErrorPrevalidation(validPrevalidation) {
    if (validPrevalidation) {
      return (this.errors.emptyPurpose = false);
    }

    this.onErrorInSelect();
    this.errors.emptyPurpose = true;
  }

  _checkErrorAmount(isSubmit) {
    const input = this.form.amount;
    this.checkAmount(isSubmit);

    if (input.$pristine && !this.amount && isSubmit) {
      return this.onErrorInAmount();
    }

    if (this.amount > this.MAX_AMOUNT) {
      this.errors.amountMax = true;
      this.errors.amountLtZero = false;
      return;
    }

    this.showErrorAmount = false;
  }

  onErrorInAmount() {
    this.showErrorAmount = true;
    this.errors.amountLtZero = true;
  }

  checkPrevalidation() {
    this.errors.prevalidation = this.hasPrevalidation && !this.preValid;
    return !this.errors.prevalidation;
  }

  checkAmount(isSubmit) {
    const input = this.form.amount;

    if (input.$pristine && !this.amount) {
      return false;
    }

    this.errors.amountLtZero = this.amount <= 0 || !this.amount;
    const valid = !this.errors.amountLtZero && this.amount < this.MAX_AMOUNT;

    if (isSubmit) {
      input.$setValidity('amount', valid);
    } else {
      input.$setValidity('amount', true);
      input.$setValidity('required', true);
    }

    return valid;
  }

  checkCharges(isSubmit) {
    const input = this.form && this.form.charges;
    const validPositive = this.charges >= 0;
    const extra = this.shouldApplyExtraPending() ? (this.extraPendingAmount09 || 0) : 0;
    const minBase = this.minChargesBase != null ? this.minChargesBase : (this.initialCharges || 0);
    const minTotal = (minBase || 0) + extra;
    const validMinimum = this.charges >= minTotal;

    this.errors.chargesError = !validPositive;
    this.errors.chargesBelowInitial = !validMinimum;

    if (!input) return validPositive && validMinimum;

    if (isSubmit) {
      input.$setValidity('chargesError', validPositive);
      input.$setValidity('chargesBelowInitial', validMinimum);
      input.$setDirty();
    } else {
      input.$setValidity('chargesError', true);
      input.$setValidity('chargesBelowInitial', true);
      input.$setValidity('required', true);
    }

    return validPositive && validMinimum;
  }

  onChangeFeeType() {
    this.checkFeeType();

    if (this.feeType !== FEE_TYPES.MONTHLY_FEE) {
      this.resetMonthlyFeeAmount();
    }

    if (this.feeType !== FEE_TYPES.FIXED_FEE_NUMBER) {
      this.resetFixedFeeNumber();
    }
  }

  checkFeeType(onSubmit) {
    if (this.feeType === FEE_TYPES.MONTHLY_FEE) {
      return this.checkMonthlyFee(onSubmit);
    } else if (this.feeType === FEE_TYPES.FIXED_FEE_NUMBER) {
      return this.checkFixedFeeNumber(onSubmit);
    }

    return true;
  }

  resetMonthlyFeeAmount() {
    this.monthlyFeeAmount = 0;
    this.errors.monthlyFeeLtZero = false;
    this.errors.monthlyFeeGtAmount = false;
    this.form.monthlyFeeAmount.$setViewValue('0,00 €');
    this.form.monthlyFeeAmount.$setValidity('amount', true);
    this.form.monthlyFeeAmount.$setPristine();
    this.form.monthlyFeeAmount.$render();
  }

  resetFixedFeeNumber() {
    this.fixedFeeNumber = 0;
    this.errors.fixedFeeNumberLtZero = false;
    this.errors.fixedFeeNumberGtDivider = false;
    this.form.fixedFeeNumber.$setViewValue('0');
    this.form.fixedFeeNumber.$setValidity('amount', true);
    this.form.fixedFeeNumber.$setPristine();
    this.form.fixedFeeNumber.$render();
  }

  checkMonthlyFee(onSubmit) {
    const input = this.form.monthlyFeeAmount;

    this.monthlyFeeAmount = this.monthlyFeeAmount || 0;

    this.errors.monthlyFeeLtZero = this.monthlyFeeAmount <= 0;
    this.errors.monthlyFeeGtAmount = this.monthlyFeeAmount > this.amount;
    const valid =
      !this.errors.monthlyFeeLtZero && !this.errors.monthlyFeeGtAmount;

    if (onSubmit) {
      input.$setValidity('amount', valid);
      input.$setDirty();
    } else {
      input.$setValidity('amount', true);
      input.$setValidity('required', true);
    }

    return valid;
  }

  checkFixedFeeNumber(onSubmit) {
    const input = this.form.fixedFeeNumber;
    this.errors.fixedFeeNumberLtZero =
      this.fixedFeeNumber <= 0 || this.fixedFeeNumber === undefined;

    if (this.loan) {
      this.errors.fixedFeeNumberGtDivider =
        this.fixedFeeNumber > this.loan.minMonthlyFeeDivider;
    }

    const valid =
      !this.errors.fixedFeeNumberLtZero && !this.errors.fixedFeeNumberGtDivider;

    if (onSubmit) {
      input.$setValidity('amount', valid);
      input.$setDirty();
    } else {
      input.$setValidity('amount', true);
      input.$setValidity('number', true);
      input.$setValidity('required', true);
    }

    return valid;
  }

  checkHousingFields(isSubmit) {
    this._checkErrorAmount(isSubmit);

    if (this.shouldShowCreditCapacitySimulation) {
      const isValidSalePriceActive = this.salePriceActive > 0;
      const isValidNewHomePrice = this.newHomePrice > 0;

      this.errors.salePriceActiveError = !isValidSalePriceActive;
      this.errors.newHomePriceError = !isValidNewHomePrice;

      if (isSubmit && this.form.salePriceActive) {
        this.form.salePriceActive.$setValidity('required', isValidSalePriceActive);
        this.form.salePriceActive.$setDirty();
      }

      if (isSubmit && this.form.newHomePrice) {
        this.form.newHomePrice.$setValidity('required', isValidNewHomePrice);
        this.form.newHomePrice.$setDirty();
      }

      this.errors.amountGtAcquisitionCost = false;
      this.errors.invalidDiff = false;

      this.setDiff();
      if (this.amount > this.diff) {
        this.errors.invalidDiffCapacitySimulation = true;
        return false;
      }

      return isValidSalePriceActive && isValidNewHomePrice;
    }

    if (!this.housingLoan) {
      return true;
    }

    if (this.housingChange) {
      this.setDiff();
      this.checkSalePrice(isSubmit);
      this.errors.invalidDiff = this.amount > this.diff;
    } else {
      this.errors.amountGtAcquisitionCost = this.amount > this.acquisitionCost;
    }

    return !this.errors.invalidDiff && !this.errors.amountGtAcquisitionCost;
  }

  checkAcquisitionCost(isSubmit) {
    const valid = this.acquisitionCost > 0;

    if (isSubmit) {
      this.form.acquisitionCost.$setValidity('amount', valid);
      this.form.acquisitionCost.$setDirty();
    } else {
      this.form.acquisitionCost.$setValidity('amount', true);
      this.form.acquisitionCost.$setValidity('required', true);
    }

    this.errors.acquisitionCostError = !valid;
  }

  checkSalePrice(isSubmit) {
    const valid = this.salePrice >= 0;

    if (isSubmit) {
      this.form.salePrice.$setValidity('amount', valid);
      this.form.salePrice.$setDirty();
    } else {
      this.form.salePrice.$setValidity('amount', true);
      this.form.salePrice.$setValidity('required', true);
    }

    this.errors.salePriceError = !valid;
  }

  setDiff() {
    this.diff = this.getDiff();
  }

  isNumber(valor) {
    return !isNaN(valor) && typeof valor === 'number';
  }
  getDiff() {
    if (this.simulationWitness) {
      const newHomePriceTemp = this.isNumber(this.newHomePrice) ? this.newHomePrice : 0;
      const salePriceActiveTemp = this.isNumber(this.salePriceActive) ? this.salePriceActive : 0;
      const chargesTemp = this.isNumber(this.charges) ? this.charges : 0;
      const diff = newHomePriceTemp - (salePriceActiveTemp - chargesTemp);
      return diff;
    } else {
      if (this.acquisitionCost === undefined && this.salePrice === undefined) {
        return 0;
      } else if (this.acquisitionCost === undefined) {
        return this.salePrice * -1;
      } else if (this.salePrice === undefined) {
        return this.acquisitionCost;
      } else {
        return this.acquisitionCost - this.salePrice;
      }
    }
  }

  focusFixedFeeNumber() {
    if (this.form.fixedFeeNumber.$pristine) {
      this.fixedFeeNumber = '';
    }

    this.checkFeeType();
  }

  initFloatingActionButtons() {
    const buttonLiteral = this.shouldShowCreditCapacitySimulation
      ? 'GLOBALS.BUTTON_ACTION.SIMULATE'
      : 'GLOBALS.BUTTON_ACTION.CONTINUE';

    this.floatingActionButtons = [{ literal: buttonLiteral }];
  }

  _setFloatingButtonDisabled(disabled) {
    if (this.isMobileApp && this.floatingActionButtons && this.floatingActionButtons[0]) {
      this.floatingActionButtons[0].disabled = !!disabled;
      if (this.scope && this.scope.$applyAsync) {
        this.scope.$applyAsync();
      }
    }
  }

  isNotInputFocus() {
    return this.floatingActionButtonsService.isFocused;
  }

  onChangeAmount() {
    this._checkErrorAmount();
    this.onchangeData();
  }

  onChangeAcquisitionCost() {
    this.checkAcquisitionCost();
    this.onchangeData();
  }

  onChangeSalePrice() {
    this.setSalePriceValueWhenEmpty();
    this.checkSalePrice();
    this.onchangeData();
  }

  onchangeData() {
    this.setDiff();
  }

  onChangeNewHomePrice() {
    this.setDiff();
  }

  onChangeSalePriceActive() {
    this.setDiff();

    const isValid = this.salePriceActive >= 0;
    this.errors.salePriceActiveError = !isValid;

    if (this.form.salePriceActive) {
      this.form.salePriceActive.$setValidity('amount', isValid);
      this.form.salePriceActive.$setDirty();
    }
  }

  onChangeCharges() {

    this.setDiff();
  }

  setSalePriceValueWhenEmpty() {
    let salePriceInput = this.form.salePrice;
    if (!this.salePrice && !salePriceInput.$pristine) this.salePrice = 0;
  }

  adquisitionShouldAppear() {
    return !this.simulationWitness && (this.codeOptionSelected === LOANS.ID_HR.HOUSING_MANDATORY_PURPOSE || this.codeOptionSelected === LOANS.ID_HR.SOCIAL_HOUSING_LOAN || this.codeOptionSelected === LOANS.ID_HR.AGREEMENT_HOUSING_LOAN);
  }
  refreshChargesInputIfPossible() {

    const input = this.form && this.form.charges;
    if (!input) return;

    if (this.isChargesFocused) return;

    input.$setViewValue(this.formattedCharges);
    input.$render();
  }
}

export default LoansAmountSimulationController;



// WEBPACK FOOTER //
// ./client/app/loans.module/components/loansAmountSimulation/loansAmountSimulation.controller.js